import { render, staticRenderFns } from "./DocumentoZerodox.vue?vue&type=template&id=490ee116&"
import script from "./DocumentoZerodox.vue?vue&type=script&lang=js&"
export * from "./DocumentoZerodox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports